import {useMemo} from 'react';
import {useUserContext} from '../context';
import {Endpoint} from '../util';
import {useQuery} from './useEndpoint';

export function useName() {
    const {user: {emailVerified} = {}} = useUserContext();
    const {
        data,
        error,
        isError,
        isPending,
    } = useQuery({
        enabled: emailVerified,
        endpoint: Endpoint.PROFILE,
    });

    const name = useMemo(() => {
        if (data) {
            const {firstName} = data;
            return firstName ?? null;
        }

        return null;
    }, [data]);

    return {
        error,
        isError,
        isPending,
        name,
    };
}
